import { styles } from "./BannerStyles";
import { Text } from "@ui/components/content/text/Text";
import { NextImage } from "@ui/components/media-and-icons/image/NextImage";
import { Box } from "@ui/components/layout/box/Box";
import { Flex } from "@ui/components/layout/flex/Flex";
import type { FC } from "react";
import type { ILink, ILinksCollection } from "@contentful-api/types/contentful";
import { Link } from "@components/cms/link/Link";
import { useBreakpoint } from "@ui/hooks/useBreakpoint";

interface IBannerProps {
    bannerItems: ILinksCollection["fields"]["links"];
}

const Banner: FC<IBannerProps> = ({ bannerItems }) => {
    const sm = useBreakpoint("sm");

    const items = bannerItems.map((link) => {
        const categoryName = link?.fields?.label || "";
        const imageUrl = (link as ILink)?.fields?.linkImage?.fields?.file?.url || "";
        return (
            <Link
                className="link"
                link={link}
                textDecor="none"
                sx={styles.bannerLink}
                key={link.sys.id}
            >
                <Flex direction="column" sx={styles.bannerItemContainer} maxW={["100%", "62.6vw"]}>
                    {sm && (
                        <Box sx={styles.bannerImage}>
                            <NextImage
                                objectFit="cover"
                                alt=""
                                src={imageUrl}
                                sizes={["50vw", "50vw", "50vw", "25vw"]}
                            />
                        </Box>
                    )}
                    <Text sx={styles.bannerText}>{categoryName}</Text>
                </Flex>
            </Link>
        );
    });

    return items.length ? (
        <Box sx={styles.parentContainer} data-testid="productBanner">
            <Flex sx={styles.container}>{items}</Flex>
        </Box>
    ) : null;
};

export default Banner;
